import { CollectionProps } from 'app/components/Core/convention'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

import { convertToFlatSubItemList } from './helpers'

type Props = {
  className?: string
}

const SubItemList: React.FC<CollectionProps<ISubItem, Props>> = ({ collection, props }) => {
  const { className } = props || {}

  const { tAttribute } = ToolBox.useString()

  function renderNameWithSubItems(item: ISubItem) {
    const subItems = convertToFlatSubItemList(item)

    return [item.name, ...subItems.map((i) => i.name)].join(', ')
  }

  return (
    <span className={className || 'text-muted text-sm'}>
      {collection
        .map(
          (item) =>
            `${renderNameWithSubItems(item)} (${tAttribute({
              recordType: RecordType.line_item,
              attribute: 'free'
            })}.)`
        )
        .join(', ')}
    </span>
  )
}

export default SubItemList
